// extracted by css-extract-rspack-plugin
export default {"titleLoadingSkeleton":"HeaderLoading-module__titleLoadingSkeleton__oQfpL","metadataLoadingSkeleton":"HeaderLoading-module__metadataLoadingSkeleton__HdGQX"};